<template>
  <div class="progress-bar" :style="{ backgroundColor: backgroundColor }">
    <div
      class="progress-bar-inner"
      :style="{ width: `${percentage}%`, background: `linear-gradient(90deg, ${progressColor.start} 0%, ${progressColor.end} 100%)` }"
    ></div>
  </div>
</template>
<script>
export default {
  name: 'ProgressBar',
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    backgroundColor: {
      type: String,
      default: '#373b43',
    },
    progressColor: {
      type: Object,
      default: () => ({
        start: '#ffba52',
        end: '#f5563c',
      }),
    },
  },
};
</script>
<style lang="scss" scoped>
.progress-bar {
  width: 360px;
  height: 8px;
  border-radius: 100px;
  .progress-bar-inner {
    width: 0%;
    height: 100%;
    border-radius: 100px;
    transition: width 0.3s ease-in-out;
  }
}
</style>
